import React from "react";

export default function DriverRecordSearch() {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>
        Authorization For Driver Record Search
      </h4>
      <p>
        The Federal Motor Carrier Safety Regulations, Section 391.21, which
        covers Drivers Qualification and application for employment, requires
        the motor carrier to obtain a list of all motor vehicle violations for
        the last three (3) years.
      </p>
      <p>
        In Ontario, this is known as a Commercial Vehicle Operator Record Driver
        Abstract. It is company policy to obtain a list of both commercial and
        personal motor vehicle violations for each driver operating under its
        authorities, on a periodic basis.
      </p>
      <p>
        As a condition of my employment/contract, I hereby provide written
        authorization for to obtain such information.
      </p>
      <p>I have read and understand the above conditions.</p>
    </div>
  );
}
